import { useSelector } from 'react-redux';

import { selectSelectedCampaign } from '../../redux/selectors';
import { Logs as OutreachLogs } from '../outreach/Logs';
import { PaymentRecoveryLogs } from '../payment-recovery/Logs';

/**
 * Post-creation wrapper: delegates logs by campaign type
 */
export const UnifiedLogs = () => {
  const campaign = useSelector(selectSelectedCampaign);

  if (campaign?.type === 'payment_recovery') {
    return <PaymentRecoveryLogs />;
  }

  return <OutreachLogs />;
};
